import { FILE_REMOVE_SERVER, TIP_SUBMIT, FILE_COMPLETE_MULTIPART_UPLOAD_REQUEST, FILE_MULTIPART_UPLOAD_REQUEST } from '@actions/types'

export const submitTip = ({ auth, data }) => ({
  type: TIP_SUBMIT,
  payload: {
    client: 'v2',
    request: {
      method: 'post',
      url: `tip/v1/send/${data.configHash}/${auth.hash}`,
      data,
      headers: { 'x-api-key': auth.apiKey }
    },
    setLoading: {
      meta: null
    }
  }
})

export const completeMultipartUploadAction = ({ data }) => ({
  type: FILE_COMPLETE_MULTIPART_UPLOAD_REQUEST,
  payload: {
    client: 'v2',
    request: {
      method: 'post',
      url: 'filestore/v1/multipart',
      data
    },
    setLoading: {
      meta: null
    }
  }
})

export const startMultipartUploadAction = ({ data }) => ({
  type: FILE_MULTIPART_UPLOAD_REQUEST,
  payload: {
    client: 'v2',
    request: {
      method: 'post',
      url: 'filestore/v1/multipart',
      data
    },
    setLoading: {
      meta: null
    }
  }
})

export const deleteFileS3 = ({ fileId }) => ({
  type: FILE_REMOVE_SERVER,
  payload: {
    client: 'v2',
    request: {
      method: 'delete',
      url: `filestore/v1/${fileId}`
    }
  }
})
